<template>
  <div class="agentStatus" :class="{ pointer: !online }" @click.stop="!online && showInfo && $emit('trash')">
    <component :is="'feather-' + brand + (online ? '' : '-gray')" :style="{ height: height, width: width }"
      v-if="brand" />
  </div>
</template>

<script>
export default {
  name: "agent-status",
  props: {
    online: {
      type: Number,
      default: 1, // change to 0, offline node will be gray
    },
    leaveTime: {
      type: [Number, String],
      default: 0,
    },
    os: {
      type: String,
      default: "",
    },
    removed: {
      type: Number,
      default: 0,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "24px",
    },
    width: {
      type: String,
      default: "24px",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      brands: [
        "android",
        "windows",
        // "ubuntu",
        // "centos",
        // "redhat",
        // "debian",
        "mac os",
        // "deepin",
        // "raspbian",
        // "kali",
        // "openwrt",
        // "linux mint",
        // "opensuse",
        // "red hat",
        // "arch linux",
        // "alpine linux",
      ],
      brandsMap: {
        "mac os": "apple-brand",
        // 'raspbian': 'raspberry',
        // 'red hat': 'redhat',
        // 'arch linux': 'archlinux',
        // 'linux mint': 'linux-mint',
        // 'alpine linux': 'alpinelinux'
      },
    }
  },
  computed: {
    tagClass() {
      return this.online ? "is-success" : "is-danger pointer"
    },
    brand() {
      let curBrand = "linux"

      if (this.os) {
        this.brands.some((brand) => {
          let os = this.os.toLowerCase()
          if (os == brand) {
            curBrand = brand
            return true
          }
          let reg = new RegExp(`${brand}( server)?( \\d*)`, "i")
          let r = os.match(reg)

          if (r === null) return false

          // let version = r[2];
          if (brand === "windows") {
            curBrand = "windows10"
            // not distinguish win7 win10
            // version > 2008 || (version > 7 && version < 1000)
            //   ? "windows10"
            //   : "windows7";
          } else {
            curBrand = this.brandsMap[brand] || brand
          }
          return true
        })
      }
      return curBrand
    },
  },
  mounted() { },
  methods: {},
}
</script>
